import { MeetingResponse } from '@/types';

/**
 * Whether a meeting belongs on the public map.
 *
 * `active` has existed since PAS-25 and nothing on the public side ever read
 * it, so the scraper's inactive detection — and the admin approval that acts on
 * it — had no public effect at all: the review said "this would deactivate a
 * live meeting", the write landed, and the meeting kept rendering.
 *
 * The test is `!== false`, NOT `=== true`. Every document written before PAS-25
 * lacks the field entirely, and treating absent as inactive would empty the map
 * of most of its ~17k meetings. This matches `mapMeeting`'s existing
 * `active ?? true` default rather than introducing a second reading of the same
 * field.
 *
 * A helper rather than an inline filter because it is the rule that decides
 * what the public sees, and the repo's convention is that such a rule lives
 * where it can be pinned.
 */
export const isPubliclyVisibleMeeting = (meeting: MeetingResponse): boolean =>
  meeting?.active !== false;
